import { axiosInstance } from './axiosInstance';

// csv-job-by-session returns raw CsvJobDetailResponse (not Result<T>)
// axiosInstance.interceptors.response returns response.data directly → no .ok/.data wrapper
export type TImportLogRes = {
  success: boolean;
  jobId: string;
  inventoryYearMonth: string; // yyyyMM
  status: string; // "COMPLETED" | "VALIDATION_FAILED" | "ACTIVATION_FAILED" | ...
  recordCount: number;
  successCount: number;
  errorCount: number;
  startedAt: string | null;
  finishedAt: string | null; // ISO datetime
  createdAt: string;
};

export type TExportDisposeReq = {
  inventoryYearMonth: string; // yyyyMM (no slash, e.g. "202603")
};

// Shape of the JSON body returned when rowCount === 0 (no disposal records).
export type TExportDisposeRes = {
  message: string;
  fileName: string;
  s3ObjectKey: string;
  rowCount: number;
};

const nxIntegrationApi = {
  /**
   * GET /api/v1/s3fileprocessor/csv-job-by-session/{sessionCode}
   * Non-standard: BE returns CsvJobDetailResponse directly (not Result<T>).
   * axiosInstance returns response.data as-is → caller receives TImportLogRes directly.
   * [AllowAnonymous] — không cần JWT.
   */
  getImportLog: async (sessionCode: string): Promise<TImportLogRes> => {
    const url = `/api/v1/s3fileprocessor/csv-job-by-session/${sessionCode}`;
    const response = await axiosInstance.get(url);
    return response as unknown as TImportLogRes;
  },

  /**
   * POST /api/v1/export/dispose
   * Xuất CSV 除却出力 (未使用資産) cho kỳ đã chọn và upload lên S3 (PC010 Tab2).
   * [Authorize] — yêu cầu JWT.
   */
  // rowCount > 0 → 200 binary CSV blob (download immediately).
  // rowCount = 0 → 200 application/json blob (parse to TExportDisposeRes, show warning).
  exportDispose: async (payload: TExportDisposeReq): Promise<Blob> => {
    try {
      const response = await axiosInstance.post<Blob>(
        '/api/v1/export/dispose',
        payload,
        { responseType: 'blob' }
      );
      return response as unknown as Blob;
    } catch (error: any) {
      const rawData = error?.data;
      if (rawData instanceof Blob) {
        let parsedData: unknown = null;
        try {
          const text = await rawData.text();
          parsedData = JSON.parse(text);
        } catch {
          parsedData = null;
        }
        throw { ...error, data: parsedData };
      }
      throw error;
    }
  },
};

export { nxIntegrationApi };
